import Vue from 'vue';
import Inputmask from 'inputmask';

Vue.directive('mask', function (el, binding, vnode) {
  const mask = binding.value;
  const input = el.getElementsByTagName('INPUT')[0];
  const config = {
    placeholder: ' ',
    jitMasking: true,
    definitions: {
      '#': {
        validator: '^[0-9]*$',
        casing: 'lower',
      },
    },
  };

  Inputmask(mask, config).mask(input);

  input.onblur = () => {
    vnode.child.$emit('input', input.value);
  };
});